/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.models
{
    export class PdfBinding extends BaseEntity implements Wars.Domain.Model.PdfBinding {
        constructor() {
            super();
            this.documents = [];
        }

        public documents: Array<any>;
        myProcessConfiguration: Wars.Domain.Model.ProcessConfiguration;
        name: string;
        boundItems: Wars.Domain.Model.BoundItem[];
        staticDocument_id: string;
        staticDocument: Wars.Domain.Model.StaticDocument;
        pages: Wars.Domain.Model.PdfBindingPage[];
        numberOfPages: number;
        currentPage: Wars.Domain.Model.PdfBindingPage;
        pdf: PDFDocumentProxy;
        processConfiguration_id: string;
    }

    export class BoundItem extends BaseEntity implements Wars.Domain.Model.BoundItem{

        constructor() {
            super();
        }

        myPdfBindingPage: Wars.Domain.Model.PdfBindingPage;
        pdfBindingPage_id: string;
        pdfInputFieldDisplayName: string;
        pdfInputFieldKey: string;
        treeItem: Wars.Domain.Model.TreeItem;
        treeItem_id: string;

        left: string;
        top: string;
        width: string;
        height: string;
        fontSize:string;
        transform: string;
        transformOrigin:string;
    }
}